/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRemoveFormattingRtl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 4.414.293 1.707 1.707.293l22 22-1.414 1.414L13 14.414V19h3v2H8v-2h3v-6.586l-6-6V7H3zM11 5H9V3h12v4h-2V5h-6v2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRemoveFormattingRtl as RemoveFormattingRtl };
